import { ErrorWithViolations as l } from "./index8.mjs";
class f extends Error {
  constructor(t) {
    var r;
    super((r = t.errors.common) == null ? void 0 : r.join("")), this.errors = t.errors;
  }
  toErrorWithViolations({
    type: t,
    status: r,
    title: e,
    code: s
  }) {
    return new l({
      type: t,
      status: r,
      title: e,
      detail: this.message,
      violations: this.flattenObjectToViolations(this.errors.fields, s, "")
    });
  }
  flattenObjectToViolations(t, r, e = "") {
    const s = [];
    return typeof t == "string" ? (s.push({ propertyPath: e, message: t, code: r }), s) : (Array.isArray(t) ? t.length === 1 ? s.push({ propertyPath: e, message: t[0], code: r }) : t.forEach((i, o) => {
      const n = `${e}[${o}]`;
      s.push(...this.flattenObjectToViolations(i, r, n));
    }) : t !== null && typeof t == "object" && Object.entries(t).forEach(([i, o]) => {
      const n = e ? `${e}.${i}` : i;
      s.push(...this.flattenObjectToViolations(o, r, n));
    }), s);
  }
}
export {
  f as ErrorWithFields
};
